module.exports = __webpack_public_path__ + "static/media/welcome.32b829c7.jpg";